package ru.villawonka.app.presentation.screens.search.viewmodel

import ru.villawonka.app.common.mvvm.SingleLiveEvent
import ru.villawonka.app.domain.model.SearchParamsDomain
import ru.villawonka.app.presentation.screens.search.model.SortTypeUIModel

sealed class SearchUIEvent : SingleLiveEvent {

    data object OpenSettingsScreen : SearchUIEvent()

    data object OpenCountrySelectScreen : SearchUIEvent()

    data object ScrollToUp : SearchUIEvent()

    data class ShowSortScreen(
        val selectedItem: SortTypeUIModel,
        val items: List<SortTypeUIModel>
    ) : SearchUIEvent()

    data class ShowFilterScreen(
        val searchParamsDomain: SearchParamsDomain,
    ) : SearchUIEvent()
}